export const visitorSubjects = ["HOW_TO_USE", "ACCOUNT_ISSUE", "PARTNERSHIP", "BECOME_EXPERT", "PERSONAL_DATA", "OTHER"];

export const expertSubjects = ["ABSENCE", "RATING", "LIVECHAT_CONSULTATION", "WRITTEN_CONSULTATION", "PHONE_CONSULTATION",
  "VIDEO_CONSULTATION", "INVOICE", "CLOSING_ACCOUNT", "PRIVATE_MESSAGE", "AFFILIATION", "CLIENT_ISSUE", "PROFILE", "ADMINISTRATION",
  "THANKS", "REMUNERATION", "STATS", "SUGGESTION", "PLANNING", "ABUSE", "OTHER"];

export const memberSubjects = ["LIVECHAT_CONSULTATION", "WRITTEN_CONSULTATION", "PHONE_CONSULTATION", "VIDEO_CONSULTATION",
  "EXPERT_RELATION", "PERSONAL_DATA", "ADDICTION", "BECOME_EXPERT", "RATING", "PRIVATE_MESSAGE", "PAYMENT", "PROFILE", "HOW_TO_USE",
  "ABUSE", "OTHER"];
